import React, { type ReactNode } from 'react';
import { Button, type ButtonProps } from '@mui/material';

type DefaultButtonProps = ButtonProps & {
  icon?: ReactNode;
};

export default function DefaultButton({
  children,
  icon,
  variant = 'outlined',
  size = 'small',
  sx,
  ...props
}: DefaultButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      startIcon={icon}
      {...props}
      sx={{ textTransform: 'none', ...sx }}
    >
      {children}
    </Button>
  );
}
